import ListCartHeaderInterface from '../interfaces/ListCartHeaderInterface';

/**
 * Update total numbers products in Cart
 */
export default class NumberProducts {
  public static execute(listProducts: ListCartHeaderInterface): number {
    const numberProducts: number = Object.values(listProducts).reduce(
      (acc, product) => {
        return acc + product.qte;
      },
      0
    );
    const cartNumberProducts: HTMLElement = document.querySelector(
      '.c-cartHeader__numberProducts'
    );
    const badgeNumberProducts: HTMLElement = document.querySelector(
      '.c-menuTertiary__item--cart .c-menuTertiary__badge'
    );
    cartNumberProducts.textContent = numberProducts.toString();

    if (numberProducts > 99) {
      badgeNumberProducts.textContent = '99+';
    } else {
      badgeNumberProducts.textContent = numberProducts.toString();
    }

    return numberProducts;
  }
}
